import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./en.json";
import es from "./es.json";

i18n.use(initReactI18next).init({
  resources: { en: { translation: en }, es: { translation: es } },
  lng: localStorage.getItem("foa_lang") || "en",
  fallbackLng: "en",
  interpolation: { escapeValue: false },
  returnEmptyString: false,
});

export function setLanguage(lang) {
  const l = lang === "es" ? "es" : "en";
  localStorage.setItem("foa_lang", l);
  i18n.changeLanguage(l);
}

export default i18n;
